import {area} from '@turf/turf'

// Old ambientations can dissolve disconnected parts into one MultiPolygon.
// Split only the map source, never the persisted data or class totals used
// by legends, prescriptions and reports. Mapbox may clip query geometries
// at tile boundaries, so compute each part's area before adding the source.
export const ambientPolygonFeatures = (geojson) => {
  if (!Array.isArray(geojson?.features)) return geojson

  return {
    ...geojson,
    features: geojson.features.flatMap((feature) => {
      if (feature.geometry?.type !== 'MultiPolygon') return [feature]

      return feature.geometry.coordinates.map((coordinates, index) => {
        const polygon = {type: 'Polygon', coordinates}
        return {
          ...feature,
          ...(feature.id !== undefined ? {id: `${feature.id}:polygon:${index}`} : {}),
          geometry: polygon,
          properties: {
            ...feature.properties,
            sup_ha: area(polygon) / 10000,
          },
        }
      })
    }),
  }
}
